import React from "react";
import * as api from "../../../../api/apiConnector.js";
import { useContext } from "react";
import UserContext from "../../../../components/User_Context.js";
import * as utils from "../../../../components/utils.js";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MessageActionButtons = ({
  answer,
  history,
  setHistory,
  toAddInTheHistory,
  setToAddInTheHistory,
  setIsStreaming,
  setCurrentQuestion,
}) => {
  const { id = null, folder_id } = useParams();
  const { currentUser } = useContext(UserContext);
  const { t } = useTranslation("labels");

  if (!answer) return null;

  const handleLikeButton = async (answer, likeValue) => {
    let value_to_set = likeValue;
    if (answer.like == likeValue) {
      value_to_set = null;
    }

    const result = (
      await api.sendMessage("dms/setAnswerLikeValue", {
        user: currentUser(),
        body: {
          answerId: answer.id,
          valueToSet: value_to_set,
        },
      })
    ).inserted[0];

    if (result) {
      if (toAddInTheHistory && toAddInTheHistory.id == result.id) {
        const newAnswer = utils.clone(toAddInTheHistory);
        newAnswer.like = result.Like;
        setToAddInTheHistory(newAnswer);
      } else {
        const historyClone = utils.clone(history);
        const messageToUpdate = historyClone.find((x) => x.id == result.id);
        if (messageToUpdate) {
          messageToUpdate.like = result.Like;
          setHistory(historyClone);
        }
      }
    }
  };

  const handleRegenerateButton = async (answer) => {
    setIsStreaming(true);
    setCurrentQuestion(answer.question);

    if (toAddInTheHistory) {
      setToAddInTheHistory(null);
    } else {
      const historyClone = utils.clone(history);
      const messageIndex = historyClone.findIndex((x) => x.id == answer.id);
      if (messageIndex > -1) {
        historyClone.splice(messageIndex, 1);
        setHistory(historyClone);
      }
    }

    const message = {
      type: "ai_query",
      query: answer.question,
      regenerate: true,
      id: window.client?.id,
      file_id: id,
      folder_id: folder_id,
      tutor: document.getElementById("ai-tutor")?.value || "AI_PLAN",
    };

   await api.sendMessage("dms/sendChatMessage", {
      user: currentUser(),
      body: {
        message,
      },
    });
  };

  const download_answer = async (history) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/dms/downloadAnswer`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: currentUser().token,
        },
        body: JSON.stringify({
          question: history.question,
          answer: history.answer,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  };
  const export_answer = async (history) => {
    const result = await api.sendMessage("dms/exportAnswer", {
      user: currentUser(),
      body: {
        file_id: id,
        folder_id: folder_id,
        question: history.question,
        answer: history.answer,
      },
    });

    if (!result.success) {
      throw new Error(result.message || t("exportError", { ns: "labels" }));
    }
    return result;
  };

  const handleShareButton = (answer, type) => {
    switch (type) {
      case "download":
        withReactContent(Swal)
          .fire({
            title: t("download", { ns: "labels" }),
            icon: "question",
            text: t("downloadDocumentQuestion", { ns: "labels" }),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Download",
            cancelButtonText: t("cancelButtonText", { ns: "labels" }),
            confirmButtonColor: "#3085d6",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                withReactContent(Swal).fire({
                  title: t("downloading", { ns: "labels" }),
                  text: t("waiting", { ns: "labels" }),
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false,
                  willOpen: () => {
                    Swal.showLoading();
                  },
                });

                const response = await download_answer(answer);
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  `${answer.question.substring(0, 30)}.docx`
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);

                withReactContent(Swal).fire({
                  title: t("downloadCompleted", { ns: "labels" }),
                  icon: "success",
                  text: t("successDownload", { ns: "labels" }),
                  confirmButtonText: t("close", { ns: "labels" }),
                });
              } catch (error) {
                console.error("Download error:", error);
                withReactContent(Swal).fire({
                  title: t("error", { ns: "labels" }),
                  icon: "error",
                  text: t("downloadError", {
                    ns: "labels",
                    errorMessage: error.message,
                  }),
                  confirmButtonText: t("close", { ns: "labels" }),
                });
              }
            }
          });
        break;
      case "export":
        withReactContent(Swal)
          .fire({
            title: t("export", { ns: "labels" }),
            icon: "question",
            text: t("exportQuestion", { ns: "labels" }),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t("exportButton", { ns: "labels" }),
            cancelButtonText: t("cancelButtonText", { ns: "labels" }),
            confirmButtonColor: "#3085d6",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                withReactContent(Swal).fire({
                  title: t("exporting", { ns: "labels" }),
                  text: t("waiting", { ns: "labels" }),
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false,
                  willOpen: () => {
                    Swal.showLoading();
                  },
                });

                const result = await export_answer(answer);
                if (result?.file?.Id) {
                  withReactContent(Swal)
                    .fire({
                      title: t("exportCompleted", { ns: "labels" }),
                      icon: "success",
                      text: t("exportQuestionModify", { ns: "labels" }),
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: t("modifyDocument", { ns: "labels" }),
                      cancelButtonText: t("cancelButtonTextTy", {
                        ns: "labels",
                      }),
                      confirmButtonColor: "#3085d6",
                    })
                    .then((editResult) => {
                      if (editResult.isConfirmed) {
                        window.location.href = `/dms/edit/${result.file.Id}`;
                      }
                    });
                } else {
                  withReactContent(Swal).fire({
                    title: t("exportCompleted", { ns: "labels" }),
                    icon: "success",
                    text: t("exportDocument", { ns: "labels" }),
                    confirmButtonText: t("close", { ns: "labels" }),
                  });
                }
              } catch (error) {
                withReactContent(Swal).fire({
                  title: t("error", { ns: "labels" }),
                  icon: "error",
                  text: t("exportError", { ns: "labels" }),
                  confirmButtonText: t("close", { ns: "labels" }),
                });
              }
            }
          });
        break;
    }
  };

  const handleOptionsButton = (answer, action) => {
    switch (action) {
      case "edit":
        console.log("edit");
        break;
      case "delete":
        console.log("delete");
        break;
    }
  };

  return (
    <div className="d-flex gap-2 action-buttons mt-2">
      <button
        className={`btn btn-sm btn-outline-secondary ${
          answer?.like === true ? "active" : ""
        }`}
        onClick={() => handleLikeButton(answer, true)}
        title={t("like", { ns: "labels" })}
      >
        <i className="fa-regular fa-thumbs-up"></i>
      </button>
      <button
        className={`btn btn-sm btn-outline-secondary ${
          answer.like === false ? "active" : ""
        }`}
        onClick={() => handleLikeButton(answer, false)}
        title={t("dislike", { ns: "labels" })}
      >
        <i className="fa-regular fa-thumbs-down"></i>
      </button>
      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={() => handleRegenerateButton(answer)}
        title={t("regenerates", { ns: "labels" })}
      >
        <i className="fa-solid fa-rotate"></i>
      </button>
      <div className="dropdown">
        <button
          className="btn btn-sm btn-outline-secondary"
          data-bs-toggle="dropdown"
          title={t("share", { ns: "labels" })}
        >
          <i className="fa-solid fa-share-nodes"></i>
        </button>
        <div className="dropdown-menu">
          <button
            className="dropdown-item"
            onClick={() => handleShareButton(answer, "download")}
          >
            <i className="fa-solid fa-download me-2"></i>
            {t("docxDownload", { ns: "labels" })}
          </button>
          <button
            className="dropdown-item"
            onClick={() => handleShareButton(answer, "export")}
          >
            <i className="fa-solid fa-file-export me-2"></i>
            {t("documentsExport", { ns: "labels" })}
          </button>
        </div>
      </div>
      {/* <div className="dropdown">
        <button
          className="btn btn-sm btn-outline-secondary"
          data-bs-toggle="dropdown"
          title={t("options", { ns: "labels" })}
        >
          <i className="fa-solid fa-ellipsis"></i>
        </button>
        <div className="dropdown-menu">
          <button
            className="dropdown-item"
            onClick={() => handleOptionsButton(answer, "edit")}
          >
            <i className="fas fa-pencil-alt me-2"></i>
            {t("edit", { ns: "labels" })}
          </button>
          <button
            className="dropdown-item"
            onClick={() => handleOptionsButton(answer, "delete")}
          >
            <i className="fa fa-trash me-2"></i>
            {t("delete", { ns: "labels" })}
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default MessageActionButtons;
